export default __webpack_public_path__ + "46ef4b07522e35f88a0c330b03b6332e.svg";